var _path, _mask, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocationNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.20833 6.08594C6.40417 6.08594 5.75 6.7401 5.75 7.5451C5.75 8.34927 6.40417 9.0026 7.20833 9.0026C8.0125 9.0026 8.66667 8.34927 8.66667 7.5451C8.66667 6.7401 8.0125 6.08594 7.20833 6.08594ZM7.20833 10.2526C5.715 10.2526 4.5 9.03844 4.5 7.5451C4.5 6.05094 5.715 4.83594 7.20833 4.83594C8.70167 4.83594 9.91667 6.05094 9.91667 7.5451C9.91667 9.03844 8.70167 10.2526 7.20833 10.2526Z",
    fill: "#7F89BE"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 15,
    height: 17
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.332031 0.667969H14.0816V16.918H0.332031V0.667969Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.20703 1.91797C4.10536 1.91797 1.58203 4.46547 1.58203 7.59547C1.58203 11.578 6.2687 15.458 7.20703 15.6646C8.14536 15.4571 12.832 11.5771 12.832 7.59547C12.832 4.46547 10.3087 1.91797 7.20703 1.91797ZM7.20703 16.918C5.71203 16.918 0.332031 12.2913 0.332031 7.59547C0.332031 3.77547 3.4162 0.667969 7.20703 0.667969C10.9979 0.667969 14.082 3.77547 14.082 7.59547C14.082 12.2913 8.70203 16.918 7.20703 16.918Z",
    fill: "#7F89BE"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationNew);
export default __webpack_public_path__ + "static/media/Location-new.5cc942e2.svg";
export { ForwardRef as ReactComponent };